import React, { Fragment } from 'react';

import Table from '../../../../../Components/Table/Table';
//import { GridLayout } from '../../../../../Components/Layout/Layout';
import ListTableImageColumn from '../../../../../Components/ListTable/ListTableImageColumn';
import Quantity from '../../../../../Components/Fragments/Quantity/Quantity';
import { getItemTotalAmount } from '../../../../../Helpers/Calculate';
import { t } from 'i18next';
export default ({
  invoice,
  currency,
  overallTax,
  subTotal,
  inModal,
  warehouseList,
  invoiceDetailsForWarehouses,
}) => {
  // console.log(overallTax, 'overallTax');
  const {
    items: invoiceItems,
    total,
    // note,
    paymentDue,
    adjustment,
    shippingCharge,
    discountLevel,
    discountTransactionLevel,
    discountType,
    discount,
    exchangeRate,
    payment_made,
    payment_via_credits,
  } = invoice;

  let ADJUSTMENT_AMPOUNT = parseFloat(adjustment).toFixed(2);
  let DISCOUNT_AMOUNT = getDiscount(
    discountTransactionLevel,
    subTotal,
    discountType
  );
  let tableHeaders = [
    t('Invoice.invoice_form.items'),
    t('Invoice.invoice_form.qty'),
    t('Invoice.invoice_form.price'),
    t('Invoice.invoice_form.tax'),
    t('Invoice.invoice_form.amount'),
  ];
  let tableData = [
    'itemName',
    'invoicedQuantity',
    'invoicePrice',
    'invoiceTax',
    'amount',
  ];
  const rightAlignColumns = [3, 4];

  if (discountLevel === 'item') {
    tableHeaders.splice(
      tableHeaders.length - 1,
      0,
      t('Invoice.invoice_form.discount')
    );
    tableData.splice(tableData.length - 1, 0, 'discount');
    subTotal = subTotal - discount;
  }
  const formatInvoicePrice = (value, symbol) => {
    const str = String(value);
    const decimalLength = str.split('.')[1]?.length || 0;

    return `${symbol}${decimalLength > 2 ? str : Number(str).toFixed(2)}`;
  };

  const items = invoiceItems.map((invoiceDetail, index) => {
    return {
      index: index + 1,

      itemName: (
        <ListTableImageColumn
          name={invoiceDetail.item_name}
          sku={invoiceDetail.item.sku}
          images={invoiceDetail.item.images}
          id={invoiceDetail.item.id}
          showModalUponClick={
            invoiceDetail?.item?.type === 'temporary' ? false : !inModal
          }
          value={invoiceDetail.extra_description}
          showExtraDisableDescription={!!invoiceDetail.extra_description}
        />
      ),
      invoicePrice: formatInvoicePrice(
        invoiceDetail?.exchanged_rate,
        currency?.symbol
      ),
      warehouse: invoiceDetail?.warehouses?.name,
      invoicedQuantity: (
        <Quantity
          quantity={invoiceDetail.quantity}
          unit={invoiceDetail.item.unit}
        />
      ),
      invoiceTax: `${invoiceDetail.exchanged_tax_amount
        ? `${currency.symbol}${parseFloat(
          invoiceDetail.exchanged_tax_amount
        ).toFixed(2)}`
        : `${currency.symbol}0.00`
        }`,
      discount: `${invoiceDetail.discount_type === 'amount'
        ? currency.symbol +
        parseFloat(
          invoiceDetail.exchanged_discount_item_level ||
          invoiceDetail.discount_item_level
        ).toFixed(2)
        : ''
        }${invoiceDetail.discount_type === 'percent'
          ? (() => {
            const value =
              invoiceDetail.exchanged_discount_item_level ??
              invoiceDetail.discount_item_level;

            // check if value has decimal part
            const formatted = value % 1 !== 0 ? value.toFixed(2) : value;

            return formatted + '%';
          })()
          : ''
        }`,

      amount: `${currency.symbol}${discountLevel === 'item'
        ? parseFloat(getItemTotalAmount(invoiceDetail)).toFixed(2)
        : parseFloat(
          invoiceDetail.quantity * invoiceDetail.exchanged_rate
        ).toFixed(2)
        }`,
    };
  });

  function getDiscount(discount, amount, type) {
    if (type === 'amount') {
      return currency.symbol + parseFloat(discount).toFixed(2);
    } else {
      return currency.symbol + (amount / 100) * discount.toFixed(2);
    }
  }

  function renderOverallTax() {
    return overallTax.map((tax) => {
      return (
        <div className="single-summary-rec mb-6" key={tax.id}>
          <span>
            {`${tax.name === 'Vat' ? t('common.vat') : tax.name} (${tax.type === 'fixed' ? currency.symbol : ''}${tax.rate}${tax.type === 'percentage' ? '%' : ''})`}
          </span>
          <span className="semi-bold">{`${currency.symbol}${parseFloat(
            tax.total
          ).toFixed(2)}`}</span>
        </div>
      );
    });
  }

  return (
    <Fragment>
      <Table
        list={items}
        tableHeaders={tableHeaders}
        tableData={tableData}
        rightAlignColumns={rightAlignColumns}
        className={
          'details-table table_view_invoice  invoice-summary uiux_invoice_table_summary ' +
          (discountLevel === 'item' ? 'discountAdded' : 'discountRemoved')
        }
      />
      <div className="invoice-summary-table">
        <div className="cus_padding">
          <div className="cust-table-summary">
            <div className="w-70 left-col">
              {/* <span>Applied Invoices:&nbsp;0</span> */}
            </div>
            <div className="w-30 right-col">
              <div className="single-summary-rec mb-6 border-bottom">
                <span className="semi-bold">
                  {t('Invoice.detail_page.subTotal')}
                </span>
                <span className="semi-bold">
                  {`${currency.symbol}${parseFloat(subTotal).toFixed(2)}`}
                </span>
              </div>
              {renderOverallTax()}
              {discountLevel === 'transaction' ||
                parseFloat(discountTransactionLevel !== 0) ? (
                <div className="single-summary-rec mb-6 ">
                  <span className="">
                    {' '}
                    {discountType === 'percent'
                      ? `${t('common.discount')} (${discountTransactionLevel}%)`
                      : t('common.discount')}{' '}
                  </span>
                  {parseFloat(DISCOUNT_AMOUNT.substring(1)) > 0 ? (
                    <span className="semi-bold" style={{ color: 'red' }}>
                      (-) {parseFloat(DISCOUNT_AMOUNT.substring(1)).toFixed(2)}
                    </span>
                  ) : (
                    <span className="semi-bold">{DISCOUNT_AMOUNT}</span>
                  )}
                </div>
              ) : null}
              <div className="single-summary-rec mb-6">
                <span className="">{t('Invoice.detail_page.adjustment')} </span>
                {parseFloat(adjustment) >= 0 ? (
                  <span className="semi-bold">
                    {' '}
                    {currency.symbol}
                    {ADJUSTMENT_AMPOUNT}
                  </span>
                ) : (
                  <span className="semi-bold" style={{ color: 'red' }}>
                    (-) {ADJUSTMENT_AMPOUNT.substring(1)}
                  </span>
                )}
              </div>

              <div className="single-summary-rec mb-6">
                <span className="">{t('Invoice.detail_page.shipping')}</span>
                <span className="semi-bold">
                  {' '}
                  {currency.symbol}
                  {parseFloat(shippingCharge).toFixed(2)}
                </span>
              </div>

              <div className="single-summary-rec mb-6">
                <span className="semi-bold">
                  {t('Invoice.detail_page.total')}
                </span>
                <span className="semi-bold">
                  {' '}
                  {currency.symbol}
                  {parseFloat(total).toFixed(2)}{' '}
                </span>
              </div>
              {payment_made > 0 && (
                <div className={payment_made > 0 ? 'border-top' : null}>
                  <div className="single-summary-rec mb-0 py-7">
                    <span>{t('Invoice.detail_page.payment_made')}</span>{' '}
                    <span className="" style={{ color: 'red' }}>
                      {`(-) ${currency.symbol}${parseFloat(
                        //exchangeRate ? payment_made * exchangeRate : payment_made
                        paymentDue == 0.01 && invoice?.originalStatus === 'paid'
                          ? total
                          : payment_made
                      ).toFixed(2)}`}
                    </span>
                  </div>
                </div>
              )}
              {payment_via_credits > 0 && (
                <div
                  className={
                    payment_made <= 0 && payment_via_credits > 0
                      ? 'border-top'
                      : null
                  }
                >
                  <div className="single-summary-rec mb-0 py-7">
                    <span>{t('Invoice.detail_page.credit_apply')}</span>{' '}
                    <span className="" style={{ color: 'red' }}>
                      {' '}
                      {`(-) ${currency.symbol}${parseFloat(
                        payment_via_credits
                      ).toFixed(2)}`}
                    </span>
                  </div>
                </div>
              )}
              <div className="single-summary-rec mb-6 border-top">
                <span className="semi-bold">
                  {t('Invoice.detail_page.balanceDue')}
                </span>
                <span className="semi-bold">
                  {' '}
                  {currency.symbol}
                  {parseFloat(
                    paymentDue == 0.01 && invoice?.originalStatus === 'paid'
                      ? 0
                      : paymentDue
                  ).toFixed(2)}{' '}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
